import { useTemplate } from "@/lib/helpers/template"
import classNames from "classnames"
import Block from "@/components/wrappers/block"
import Blocks from "@/components/Blocks"
import BlockHeader from "@/common/partials/block-header/block-header"
import styles from "./files.module.css"

export default function Files({ block }) {
  const template = useTemplate()
  const { attrs, innerBlocks } = block
  const { bgColor = "transparent", blockGap, heading, text } = attrs

  if (innerBlocks.length === 0) {
    return null
  }

  const defaultGap = template === "article" ? "content" : "normal"
  const gap =
    template === "article" && blockGap === "normal"
      ? "content"
      : blockGap ?? defaultGap

  return (
    <Block
      block={block}
      width="bleed"
      gap={gap}
      className={classNames(styles.files, "bg-color-" + bgColor)}>
      <div className="inner-wrapper">
        {template !== "article" && (
          <BlockHeader align="inner-column" heading={heading} text={text} />
        )}
        <ol>
          <Blocks blocks={innerBlocks} />
        </ol>
      </div>
    </Block>
  )
}
